var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"workbench"},_vm._l((_vm.list),function(item,index){return _c('span',{key:index,class:item.id==_vm.active?'workbenchAct':'',on:{"click":function($event){return _vm.change(item.id)}}},[_vm._v(_vm._s(item.name))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }